import { DragHandleOutlined } from "@mui/icons-material";
import { LinearProgress } from "@mui/material";
import { GridSlots } from "@mui/x-data-grid-premium";
import { TableElement } from "@types";

import { StepValue } from "@types";

export const parseTable = (
  columnDefs: {
    name: string;
    options?: {
      flex?: number;
    };
  }[],
  value: string
) => {
  const lines = value.split("\n").filter((line) => line.trim() !== "");

  // Remove the separator line
  lines.splice(1, 1);

  const rows = lines.slice(1);

  if (rows.length === 0) {
    return [];
  }

  const processedRows: {
    index: number;
    parsedRow: Record<string, string>;
  }[] = [];

  rows.forEach((row, rowIndex) => {
    let cells = row
      .split("|")
      .slice(1, -1)
      .map((cell) => cell.trim());

    cells = [...cells, ...Array(columnDefs.length - cells.length).fill("")];

    const parsedRow: Record<string, string> = {};
    cells.forEach((cell, columnIndex) => {
      parsedRow[columnDefs[columnIndex].name] = cell;
      parsedRow["id"] = rowIndex.toString();
    });

    processedRows.push({ index: rowIndex, parsedRow });
  });

  return processedRows.map((row) => row.parsedRow);
};

export const tableStyles = (isFetchingSuggestion: boolean) => ({
  backgroundColor: "white",
  lineHeight: 1.5,
  fontSize: "1rem",
  pointerEvents: isFetchingSuggestion ? "none" : "auto",
  ".MuiDataGrid-cell": {
    backgroundColor: "unset !important",
    whiteSpace: "pre-wrap",
    lineHeight: "1.5em",
    padding: "8px 16px",
  },

  ".MuiDataGrid-cell.MuiDataGrid-cell--editing": {
    backgroundColor: "unset",
    boxShadow: "unset",
  },
  "& .MuiDataGrid-row:has(.MuiDataGrid-cell--editing):hover": {
    backgroundColor: "transparent",
  },

  "& .MuiDataGrid-row:hover": {
    cursor: "pointer",
  },

  ".MuiInputBase-input": {
    paddingLeft: "0",
  },

  ".MuiDataGrid-overlayWrapper": {
    height: isFetchingSuggestion ? "4px" : 100,
  },
  ".MuiDataGrid-cell:not(:last-child), .MuiDataGrid-columnHeader:not(:last-child)":
    {
      borderRight: "1px solid rgb(224, 224, 224)",
    },

  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
    py: "8px",
  },
  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
    py: "9px",
  },
  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
    py: "22px",
  },
  ".MuiDataGrid-editInputCell": {
    px: "9px",
    fontSize: "1rem",
    lineHeight: "1.5em",
    py: "0",
  },
  ".MuiDataGrid-columnHeader:focus, .MuiDataGrid-columnHeader:focus-within": {
    outline: "none",
  },
  ".MuiDataGrid-columnHeaderTitle": {
    fontWeight: "bold",
    whiteSpace: "wrap",
  },

  ".MuiDataGrid-cellContent": {
    whiteSpace: "pre-wrap",
    lineHeight: "1.5em",
    display: "block",
  },

  ".MuiDataGrid-row:last-child .MuiDataGrid-cell": {
    borderBottom: "none",
  },
  ".MuiDataGrid-container--top [role=row]": {
    backgroundColor: "transparent",
  },
});

// Put props outside of the component to avoid re-creating them on each render
// https://mui.com/x/react-data-grid/performance/#extract-static-objects-and-memoize-root-props
export const slots = {
  loadingOverlay: LinearProgress as GridSlots["loadingOverlay"],
  rowReorderIcon: DragHandleOutlined,
};

export const autosizeOptions = {
  includeOutliers: false,
  includeHeaders: true,
  expand: true,
};

export type Props = {
  value: string;
  element: TableElement;
  isFetchingSuggestion: boolean;
  onChange?: (id: string, value: StepValue) => void;
};
